/*
 * File: GetGeneralStudentAgreement.ts
 * Author: Austin Robinson
 * Date Created: 8/17/2025
 * Copyright (c) DrivingDoc 2025
 */
import { SerializedEditorState } from 'lexical';
import { createQuery } from 'react-query-kit';

import { MinimalUser, privateApi } from 'api';

export type GetGeneralStudentAgreementParams = {
  tenant_id: string;
};

export type GetAgreementResult = {
  id: string;
  tenant_id: string;
  agreement_versions: {
    agreement_id: string;
    version: number;
    tenant_id: string;
    content: SerializedEditorState;
    effective_at: Date;
    created_at: Date;
    created_by?: string | null;
    created_by_user: MinimalUser | null;
  }[];
  created_at: Date;
  created_by?: string | null;
  created_by_user: MinimalUser | null;
};

async function getGeneralStudentAgreement(params: GetGeneralStudentAgreementParams): Promise<GetAgreementResult> {
  // make api call
  const result = await privateApi.get<GetAgreementResult>(
    `${import.meta.env.VITE_API_BASE_URL}/tenants/${params.tenant_id}/agreements/general-student`,
    {},
  );

  // return the data object
  return result.data;
}

const useGetGeneralStudentAgreement = createQuery<GetAgreementResult, GetGeneralStudentAgreementParams, Error>({
  queryKey: ['general_student_agreement'],
  fetcher: (variables) => getGeneralStudentAgreement(variables),
});

export { getGeneralStudentAgreement, useGetGeneralStudentAgreement };
